// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, doc, getDoc } from "firebase/firestore"; // Import required Firestore functions
import { ref, get } from "firebase/database";  // Import modular functions for database

// Your Firebase configuration (replace these with your actual Firebase project details)
const firebaseConfig = {
   apiKey: "AIzaSyAfGig9Tvgj-gIMTLifj03-X6DTta6tu5k",
  authDomain: "rohith-muthusamy.firebaseapp.com",
  projectId: "rohith-muthusamy",
  storageBucket: "rohith-muthusamy.firebasestorage.app",
  messagingSenderId: "660762375946",
  appId: "1:660762375946:web:01c6d79bd02f68c7d12cf3",
  measurementId: "G-8R801MVVBF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore

// Export necessary functions for use in other components
export { ref, get,app, db, collection, getDocs, doc, getDoc }; // Export the required methods
